// Steps/NotificationContent.js - Step 4 Component
import React, { useContext } from 'react';
import {
    Box,
    Typography,
    Grid,
    TextField,
    Paper,
    Chip,
    Card,
    CardContent,
    Divider,
    Alert,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Avatar
} from '@mui/material';
import {
    People,
    Engineering,
    Schedule,
    NotificationsActive,
    Sms,
    WhatsApp,
    Email,
    Title,
    Description,
    CheckCircle
} from '@mui/icons-material';
import dayjs from 'dayjs';
import { NotificationDataContext } from '../AddEditNotification';

const NotificationContent = () => {
    const { notificationData, setNotificationData } = useContext(NotificationDataContext);

    const selectedAudience = notificationData.audienceType === 'customer' 
        ? notificationData.customerFilters.selectedCustomers 
        : notificationData.expertFilters.selectedExperts;

    const handleTitleChange = (event) => {
         const cleanedValue = event.target.value
            .replace(/\s+/g, ' ') // Replace multiple spaces with single space
            .trimStart(); // Remove leading spaces
        
        setNotificationData(prev => ({
            ...prev,
            title: cleanedValue
        }));
        // setNotificationData(prev => ({
        //     ...prev,
        //     title: event.target.value
        // }));
    };

    const handleBodyChange = (event) => {
        const cleanedValue = event.target.value
            .replace(/\s+/g, ' ') // Replace multiple spaces with single space
            .trimStart(); // Remove leading spaces
        
        setNotificationData(prev => ({
            ...prev,
            body: cleanedValue
        }));
        // setNotificationData(prev => ({
        //     ...prev,
        //     body: event.target.value
        // }));
    };

    const getDeliveryModeIcon = (mode) => {
        switch (mode) {
            case 'push': return <NotificationsActive sx={{ fontSize: 16 }} />;
            case 'sms': return <Sms sx={{ fontSize: 16 }} />;
            case 'whatsapp': return <WhatsApp sx={{ fontSize: 16 }} />;
            case 'email': return <Email sx={{ fontSize: 16 }} />;
            default: return <NotificationsActive sx={{ fontSize: 16 }} />;
        }
    };

    const getDeliveryModeLabel = (mode) => {
        switch (mode) {
            case 'push': return 'Push Notification';
            case 'sms': return 'SMS';
            case 'whatsapp': return 'WhatsApp';
            case 'email': return 'Email';
            default: return 'Unknown';
        }
    };

    const isFormValid = notificationData.title.trim() !== '' && 
                       notificationData.body.trim() !== '' &&
                       selectedAudience.length > 0 &&
                       notificationData.deliveryModes.length > 0 &&
                       (notificationData.scheduleType === 'now' || 
                        (notificationData.scheduleType === 'later' && notificationData.scheduledDateTime));

    return (
        <Box>
            <Typography gutterBottom sx={{ mb: 1, fontWeight: 600 ,fontSize:'0.85rem'}}>
                Notification Content
            </Typography>

            <Grid container spacing={3}>
                {/* Message Composition */}
                <Grid item xs={12} md={8}>
                    <Card variant="outlined">
                        <CardContent>
                            <Typography variant="subtitle1" gutterBottom sx={{ 
                                fontWeight: 600, 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: 1,
                                mb: 2
                            }}>
                                <Title color="primary" />
                                Compose Your Message
                            </Typography>

                            <TextField
                                fullWidth
                                label="Notification Title"
                                value={notificationData.title}
                                onChange={handleTitleChange}
                                required
                                size="small"
                                sx={{ mb: 2 }}
                                InputProps={{
                                    style: { fontSize: '0.8rem' }
                                }}
                                InputLabelProps={{
                                    style: { fontSize: '0.8rem' }
                                }}
                                helperText="Keep it concise and attention-grabbing"
                            />

                            <TextField
                                fullWidth
                                label="Notification Body"
                                multiline
                                rows={4}
                                value={notificationData.body}
                                onChange={handleBodyChange}
                                required
                                size="small"
                                InputProps={{
                                    style: { fontSize: '0.75rem' }
                                }}
                                InputLabelProps={{
                                    style: { fontSize: '0.8rem' }
                                }}
                                helperText={`${notificationData.body.length}/200 characters recommended`}
                            />
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                    {/* Message Preview */}
                            {notificationData.title && notificationData.body && (
                                <Box sx={{}}>
                                    <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                                        Preview:
                                    </Typography>
                                    <Paper 
                                        sx={{ 
                                            p: 2, 
                                            bgcolor: 'grey.50', 
                                            border: '1px dashed', 
                                            borderColor: 'grey.300',
                                            // maxWidth: 300
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                                            <Avatar sx={{ width: 24, height: 24, bgcolor: 'primary.main' }}>
                                                <NotificationsActive sx={{ fontSize: 14 }} />
                                            </Avatar>
                                            <Box sx={{ flex: 1 }}>
                                                <Typography variant="subtitle2" sx={{ 
                                                    fontWeight: 600, 
                                                    fontSize: '0.8rem',
                                                    lineHeight: 1.2,
                                                    mb: 0.5
                                                }}>
                                                    {notificationData.title}
                                                </Typography>
                                                <Typography variant="body2" sx={{ 
                                                    fontSize: '0.7rem',
                                                    color: 'text.secondary',
                                                    lineHeight: 1.3
                                                }}>
                                                    {notificationData.body}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Paper>
                                </Box>
                            )}
                </Grid>
            </Grid>
        </Box>
    );
};

export default NotificationContent;